import zhCN from '@sinohealth/butterfly-ui-antd/lib/locale/zh_CN';
import { ConfigProvider, Spin } from '@sinohealth/butterfly-ui-components/lib';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
// Calendar/DatePicker 使用 butterfly 内嵌 dayjs，需同步中文周起始（周一）
import antdDayjs from '@sinohealth/butterfly-ui-antd/node_modules/dayjs';
import '@sinohealth/butterfly-ui-antd/node_modules/dayjs/locale/zh-cn';
import antdLocaleData from '@sinohealth/butterfly-ui-antd/node_modules/dayjs/plugin/localeData';
import antdWeekday from '@sinohealth/butterfly-ui-antd/node_modules/dayjs/plugin/weekday';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import App from './App';
// import '@sinohealth/butterfly-ui-antd/dist/@sinohealth/butterfly-ui-antd.css';
import '@/style/iconfont/iconfont.css';
import '@sinohealth/butterfly-ui-components/lib/index.css';
import { currThemeData } from './config/base';

dayjs.extend(customParseFormat);
dayjs.extend(localeData);
dayjs.extend(weekday);
dayjs.extend(weekOfYear);
dayjs.locale('zh-cn');
moment.locale('zh-cn');

antdDayjs.extend(antdLocaleData);
antdDayjs.extend(antdWeekday);
antdDayjs.locale('zh-cn');

const loading = (
  <div style={{ display: 'flex', height: '100vh' }}>
    <Spin size="large" style={{ margin: 'auto' }} />
  </div>
);
ReactDOM.render(
  <ConfigProvider
    locale={zhCN}
    theme={{
      token: { ...currThemeData, borderRadius: 4 },
      components: { Menu: { colorItemBgSelected: '#EFFAFF' } },
    }}
  >
    <RecoilRoot>
      <Suspense fallback={loading}>
        <HashRouter>
          <App />
        </HashRouter>
      </Suspense>
    </RecoilRoot>
  </ConfigProvider>,
  document.getElementById('root'),
);
